export function loadFonts(fonts) {
  let fragment = document.createDocumentFragment();
  fonts.forEach((font) => {
    let _font = font.replace(/ /g, "_");
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = `${window.publicPath}media/fonts/${_font}/${_font}.css`;
    fragment.appendChild(link);
  });
  document.head.appendChild(fragment);
}
